import { render, staticRenderFns } from "./MpChooseList.vue?vue&type=template&id=428465ec&scoped=true&"
import script from "./MpChooseList.vue?vue&type=script&lang=js&"
export * from "./MpChooseList.vue?vue&type=script&lang=js&"
import style0 from "./MpChooseList.vue?vue&type=style&index=0&id=428465ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428465ec",
  null
  
)

export default component.exports